import React, { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import moment from 'moment';

import { useSolicitacaoGuias } from '../../../../contexts/SolicitacaoGuias/context';

import steps from '../../../../utils/steps.json';

import StepProgress from '../../../../components/StepProgress';
import FormContainer from '../../../../components/FormContainer';
import Input from '../../../../components/Inputs/Input';
import Button from '../../../../components/Button';
import DatepickerMui from '../../../../components/Inputs/DatepickerMui';
import Radio from '../../../../components/Inputs/Radio';
import Accordion from '../../../../components/Accordion';
import Divider from '../../../../components/Divider';
import Select from '../../../../components/Inputs/Select';
import Modal from '../../../../components/Modal';
import TextAreaInput from '../../../../components/Inputs/TextAreaInput';

import schema from './schema';
import validate from '../../../../utils/validateForm';

import { cloneObject, addMaskCellphone } from '../../../../utils';

import { PageContainer, ContainerButton } from '../../../../styles/styles';

import * as S from './styles';
import Alertas from '../Alertas';
import { getCategoria, getSubCategoria } from '../../../../services/registroAcidentados/solicitacaoGuias';
import PageLoader from '../../../../components/PageLoader';

function PreencherDados() {
    const history = useHistory();
    const [showModal, setShowModal] = useState(false);
    const [modalMessage, setModalMessage] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
    const { dataBeneficiario, setDataInputForm, dataInputForm, setDataSolicitacaoGuias } = useSolicitacaoGuias();
    const [dataForm, setDataForm] = useState(dataInputForm.fullName ? cloneObject(dataInputForm) : cloneObject(schema));

    async function loadCategorias() {
        const categoria = 'IMS';
        const nivelAcesso = 'BENEFICIARIO';

        try {
            const categorias = await getCategoria(categoria, nivelAcesso);

            const categoriasFiltered = categorias?.map((element) => ({
                codigo: element.codigo,
                nome: element.descricao,
            }));

            return categoriasFiltered
        } catch (error) {
            console.error(error)
        }

        return []
    }

    async function loadSubCategorias(codCategoria) {
        const subcategorias = (await getSubCategoria(codCategoria)) || [];

        const subCategoriasFiltered = subcategorias?.map((element) => ({
            codigo: element.codigo,
            nome: element.descricao,
        }));

        return subCategoriasFiltered;
    }

    function exibirNumeroTelefone() {
        const endereco = !!dataBeneficiario[0]?.enderecos?.lenth

        if (!endereco) return null
        const telefone = dataBeneficiario[0]?.enderecos[0]?.telefone
        return telefone.lenth ? addMaskCellphone(telefone[0].ddd + telefone[0].numero) : null
    }

    async function loadData() {
        setIsLoading(true);
        const categorias = await loadCategorias();

        const initialValues = {
            ...dataForm,
            fullName: {
                ...dataForm.fullName,
                value: dataBeneficiario[0]?.nomeCompleto,
                disabled: true,
            },
            cardNumber: {
                ...dataForm.cardNumber,
                value: dataBeneficiario[0]?.numCarteirinha,
                label: 'Nº Carteirinha',
                require: true,
                disabled: true,
            },
            note: {
                ...dataForm.note,
                value: dataForm.note.value?.length ? dataForm.note.value : '',
                error: '',
            },
            email: {
                ...dataForm.email,
                value: dataBeneficiario[0]?.email,
                error: '',
            },
            cellphone: {
                ...dataForm.cellphone,
                value: exibirNumeroTelefone(),
                error: '',
            },
            requestType: {
                ...dataForm.requestType,
                options: categorias,
            },
        };

        setDataForm({
            ...dataForm,
            ...initialValues,
        });

        setIsLoading(false);
    }

    useEffect(() => {
        loadData();
    }, []);

    async function handleInputChange(event) {
        setIsLoading(true)
        const { id, value, unmaskedValue, lookup, ...rest } = event;
        let codCategoria;
        let regionValue = {};

        if (event.id === 'requestType') {
            codCategoria = value;
            let subcategorias = [];

            try {
                subcategorias = await loadSubCategorias(codCategoria);
            } catch (error) {
                setIsLoading(false);
            } finally {
                /* eslint-disable no-unneeded-ternary */
                regionValue = {
                    ...dataForm,
                    areaRegion: {
                        ...dataForm.areaRegion,
                        options: subcategorias,
                    },
                    surgeryDate: {
                        ...dataForm.surgeryDate,
                        required: codCategoria === '4' ? true : false
                    }
                };
            }
        }

        const field = {
            ...cloneObject(dataForm[id]),
            value,
            lookup,
            unmaskedValue,
            error: '',
            ...rest,
        };

        setDataForm({
            ...dataForm,
            ...regionValue,
            [id]: field,
        });

        setIsLoading(false);
    }

    async function handleFowardStep() {
        setIsLoading(true);
        const { validatedForm, isValid } = validate(dataForm);
        let invalido = false;

        if (isValid) {
            if (validatedForm.note.value.length < 10) {
                setModalMessage('O campo de observação precisa conter no mínimo 10 caracteres.');
                setShowModal(true);
                invalido = true;
                setIsLoading(false);

                return;
            }
        }

        if (invalido) {
            setIsLoading(false);
            return;
        }

        setDataForm({
            ...dataForm,
            ...validatedForm,
        });

        if (isValid) {
            setDataInputForm(validatedForm);

            const payload = {
                cabecalho: {
                    token: null,
                    unidadeNegocio: '1',
                    divisaoNegocio: '1',
                    origemContrato: '1',
                    empresaOrigemAtendimento: '1',
                    tipoContrato: '1',
                    codigoEmpresaOrigem: '1',
                    canal: 'P',
                },
                carteirinha: dataBeneficiario[0]?.numCarteirinha,
                idCategoria: validatedForm?.requestType?.value,
                idSubCategoria: validatedForm?.areaRegion?.value,
                nivelAcesso: 'BENEFICIARIO',
                email: dataBeneficiario[0]?.email,
                numeroPreviaReembolso: '',
                observacao: validatedForm?.note.value,
                numeroCelular: validatedForm?.cellphone.value,
                numeroFax: '',
                localAtendimento: validatedForm?.exameLocation.value ? validatedForm?.exameLocation.value : '',
                dataCirurgia: validatedForm?.surgeryDate.value
                    ? new Date(validatedForm?.surgeryDate.value).toLocaleString().split(',')[0]
                    : '',
                from: dataBeneficiario[0]?.nomeCompleto,
                tamanhoTotalArquivoComprensado: '',
                tamanhoTotalArquivoReal: '',
                nomeContato: dataBeneficiario[0]?.nomeCompleto,
                numeroSolicitacaoReembolso: '',
                numeroAutorizacao: '',
                credencial: '',
                divisaoCategoria: 'Intermedica',
                descricaoCategoria: validatedForm?.requestType?.lookup,
                descricaoSubCategoria: validatedForm?.areaRegion?.lookup,
                numeroTelefone: '',
                gestanteOuRN:
                    validatedForm?.pregnant.value === 'S' || validatedForm?.newborn.value === 'S' ? '58951' : '58952',
                descricaoPrestadorHospital: '',
                dataSolicitacao: moment(new Date()).format('DD/MM/YYYY'),
                procedimento: '',
                opcaoURA: 'NAO',
                solicitante: dataBeneficiario[0]?.nomeCompleto,
                tipoServico: '',
            };

            setDataSolicitacaoGuias(payload);
            setIsLoading(false);

            history.push({
                pathname: '/dados_beneficiario/carregar_documentos_solicitacao_guias',
            });
        } else {
            setIsLoading(false);
            setTimeout(() => {
                const firstElementWithError = document.querySelector('.error');

                if (firstElementWithError) {
                    firstElementWithError.scrollIntoView({
                        block: 'center',
                        behavior: 'smooth',
                    });
                }
            }, 300);
        }
    }

    return (
        <>
            <PageContainer>
                <StepProgress steps={steps.solicitacaoGuias} activeStep={2} />

                <Alertas />

                <Accordion title="Dados do Beneficiário" hasCollapse={false}>
                    <FormContainer>
                        <Input field={{ ...dataForm.fullName }} />
                        <Input field={{ ...dataForm.cardNumber }} />
                    </FormContainer>
                    <FormContainer>
                        <Input field={{ ...dataForm.cellphone }} onChange={handleInputChange} />
                        <Input field={{ ...dataForm.email }} onChange={handleInputChange} />
                        <Radio field={{ ...dataForm.pregnant }} onChange={handleInputChange} />
                        <Radio field={{ ...dataForm.newborn }} onChange={handleInputChange} />
                        <Select field={{ ...dataForm.requestType }} onChange={handleInputChange} />
                        <Select field={{ ...dataForm.areaRegion }} onChange={handleInputChange} />
                        <DatepickerMui field={{ ...dataForm.surgeryDate }} onChange={handleInputChange} />
                        <Input field={{ ...dataForm.exameLocation }} onChange={handleInputChange} />                     </FormContainer>
                    <TextAreaInput field={{ ...dataForm.note }} maxLength={100} onChange={handleInputChange} />
                    <Modal
                        title="Atenção"
                        subtitle={modalMessage}
                        modalSize="sm"
                        visible={showModal}
                        onCancel={() => setShowModal(false)}
                        footer={null}
                    />
                </Accordion>
                <S.ShowLength>{dataForm.note.value.length}/100</S.ShowLength>
                <Divider />

                <ContainerButton>
                    <Button
                        id="backStep"
                        type="secondary"
                        className="hide-mobile"
                        onClick={() => history.push('/dados_beneficiario/selecionar_solicitacao_guias')}
                    >
                        Voltar
                    </Button>

                    <Button id="continueStep" type="primary" onClick={handleFowardStep}>
                        Continuar
                    </Button>
                    <PageLoader loading={isLoading} />
                </ContainerButton>
            </PageContainer>
        </>
    );
}

export default PreencherDados;
